import { z } from 'zod';
import { defineEndpoint } from '../define';

const BaselineOptionSchema = z.object({
  id: z.string().uuid(),
  version: z.string(),
  buildNumber: z.number().int(),
});

export const listReleaseBaselines = defineEndpoint({
  method: 'GET',
  path: '/v1/releases/:releaseId/baselines',
  params: z.object({ releaseId: z.string().uuid() }),
  query: z.object({
    q: z.string().trim().max(100).optional(),
    offset: z.coerce.number().int().min(0).max(2147483647).default(0),
  }),
  body: z.undefined(),
  response: z.object({
    data: z.array(BaselineOptionSchema),
    meta: z.object({
      automatic: BaselineOptionSchema.nullable(),
      selected: BaselineOptionSchema.nullable(),
      nextOffset: z.number().int().nullable(),
    }),
  }),
});
